/**
 * Ring buffer de requests TRAZiT via fetch (trazit-tracking #87).
 * Instalar despues de merge-action-master-data.
 */

import {
  isTrazitApiUrl,
  pushApiRequestLog,
  redactUrlForLog,
  sanitizeForIncidentContext,
} from './incident-context-capture.js';

const PATCH_FLAG = '__trazitIncidentApiLogInstalled';

function extractActionName(urlStr) {
  try {
    const u = new URL(urlStr, window.location.origin);
    return u.searchParams.get('actionName') || u.searchParams.get('queryName') || '';
  } catch (_) {
    return '';
  }
}

function summarizeResponseBody(data) {
  if (!data || typeof data !== 'object') return {};
  const summary = {};
  if (data.is_error === true || data.isError === true) summary.isError = true;
  if (data.message) summary.message = String(data.message).slice(0, 500);
  if (data.error_code != null) summary.error_code = data.error_code;
  if (Array.isArray(data.data)) summary.dataRowCount = data.data.length;
  return sanitizeForIncidentContext(summary);
}

export function installIncidentApiRequestLog() {
  if (typeof window === 'undefined') return;
  if (window[PATCH_FLAG]) return;
  window[PATCH_FLAG] = true;

  const orig = window.fetch.bind(window);

  window.fetch = async function patchedFetchForIncidentLog(input, init) {
    const urlStr =
      typeof input === 'string'
        ? input
        : input && typeof input.url === 'string'
          ? input.url
          : '';
    const method = (init?.method || (input && input.method) || 'GET').toUpperCase();
    const shouldLog = isTrazitApiUrl(urlStr);
    const started = Date.now();

    const response = await orig(input, init);

    if (!shouldLog) return response;

    const entry = {
      at: new Date().toISOString(),
      method,
      url: redactUrlForLog(urlStr),
      actionName: extractActionName(urlStr),
      status: response.status,
      ok: response.ok,
      durationMs: Date.now() - started,
    };

    const ct = response.headers.get('content-type') || '';
    if (response.ok && ct.includes('json')) {
      try {
        const data = await response.clone().json();
        entry.responseSummary = summarizeResponseBody(data);
      } catch (_) {}
    }

    pushApiRequestLog(entry);
    return response;
  };
}
